import DOMPurify from 'dompurify';

export function useDomPurify() {

  const allowedTags = [
    'p', 'img', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'strong', 'em', 'a', 'ul', 'ol', 'li',
    'figure', 'figcaption', 'br',
  ];

  const allowedAttr = ['href', 'src', 'id', 'target', 'rel'];

  DOMPurify.addHook('afterSanitizeAttributes', function(node) {
    // Check if the current node is an anchor tag
    if (node.tagName === 'A') {
      // Force target="_blank"
      node.setAttribute('target', '_blank');

      // Force security attributes to prevent reverse tabnabbing
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  // sometimes tinymce decides to use \ns which dont get rendered inside inline elements
  const sanitize = content => {
    const processedContent = content ? String(content).replace(/<\/p>\n<p>/g, '</p><br><p>') : '';

    return DOMPurify.sanitize(processedContent, {
      ALLOWED_TAGS: allowedTags,
      ALLOWED_ATTR: allowedAttr,
    });
  };

  return { sanitize };
}
